export const wotcInterestRoute = '/wotc/wotc-interest/';
export const getWotcApplicationsRoute = '/employer/applicants/wotc-dashboard/';
export const deleteWotcApplicationRoute = '/wotc/survey/applicant/delete/';
export const rockerboxDocumentsRoute = '/rockerbox/documents/';
export const wotcSurveyRoute = '/wotc/survey/';
